class StereoPanNode extends Weaver.Node

  @className = 'StereoPanNode'

  constructor: (id) ->
    super(id)

  create: (name = "New Stereo Pan", pan = 0) ->
    type = await Weaver.Node.firstOrCreate('StereoPan')
    @set('name', name)
    @set('pan', pan)
    @relation('type').add(type)
    @save()

export default StereoPanNode
